<template>
    <div>
        <div class="grey lighten-5 pt-4 px-4 pb-3">
            <v-layout align-start>

                <v-icon small color="primary" class="mr-3 mt-2" v-if="back==undefined && icon">{{icon}}</v-icon>

                <v-icon size="20px" color="accent" class="mr-3 mt-2" @click="$router.push(linkTo)" v-if="back">fa-arrow-left</v-icon>

                <div>
                    <div class="subheading font-weight-medium black--text" v-html="title"></div>
                    <div class="font-weight-light" style="margin-top:-2px" v-html="subtitle"></div>
                </div>
                
            </v-layout>
        </div>

        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
    props: ['title', 'subtitle', 'icon', 'back', 'linkTo']
}
</script>

